import React, { useState } from 'react'
import BootScreen from './screens/BootScreen/BootScreen'
import LockScreen from './screens/LockScreen/LockScreen'
import HomeScreen from './screens/HomeScreen/HomeScreen'
import { VolumeProvider } from './contexts/VolumeContext'
import { MusicProvider } from './contexts/MusicContext'
import { BatteryProvider, useBattery } from './contexts/BatteryContext'
import { useVolume } from './contexts/VolumeContext'
import { useMusic } from './contexts/MusicContext'
import VolumeIndicator from './components/Volume/VolumeIndicator'
import BatteryDead from './components/StatusBar/BatteryDead'

function AppContent() {
  const [unlocked, setUnlocked] = useState(false)
  const [bootComplete, setBootComplete] = useState(() => {
    return localStorage.getItem('system_booted') === 'true'
  })
  const { volume, showIndicator } = useVolume()
  const { setBattery, isDead, setIsDead } = useBattery()
  const { isSystemReady } = useMusic()

  const handleChargingComplete = () => {
    setBattery(100)
    setIsDead(false)
  }

  const handleBootComplete = () => {
    localStorage.setItem('system_booted', 'true')
    setBootComplete(true)
  }

  if (!bootComplete) {
    return (
      <BootScreen 
        onBootComplete={handleBootComplete} 
        isSystemReady={isSystemReady}
      />
    )
  }

  return (
    <>
      <div style={{ position: 'relative', height: '100vh', overflow: 'hidden' }}>
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 1 }}>
          <HomeScreen isLocked={!unlocked} />
        </div>

        {!unlocked && (
          <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 10 }}>
            <LockScreen onUnlock={() => setUnlocked(true)} />
          </div>
        )}

        {isDead && (
          <BatteryDead onChargingComplete={handleChargingComplete} />
        )}
      </div>

      <VolumeIndicator volume={volume} isVisible={showIndicator} />
    </>
  )
}

function AppWithMusic() {
  const { volume } = useVolume()

  return (
    <MusicProvider systemVolume={volume}>
      <AppContent />
    </MusicProvider>
  )
}

export default function App() {
  return (
    <VolumeProvider>
      <BatteryProvider>
        <AppWithMusic />
      </BatteryProvider>
    </VolumeProvider>
  )
}